import o from "@kmx/mui-icons/KmxCaretDownFilled";
const e = {
  defaultProps: {
    native: !0,
    IconComponent: o
  }
};
export {
  e as default
};
